import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';
import SvgIcon from '../common/SvgIcon';
import StepHeader from '../../includes/StepHeader';
import { setSMEPaymentAddPayee } from '../../actions/MoveMoneySMEActionCreator';
import InternetBankingActions from '../../actions/InternetBankingActions';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import NumberUtils from '../../utils/NumberUtils';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';

class AddPayeeSummary extends Component {
  constructor(props) {
    super(props);
    this.showPayeePage = this.showPayeePage.bind(this);
    this.goToMoveMoneyPage = this.goToMoveMoneyPage.bind(this);
    this.goToManagePayees = this.goToManagePayees.bind(this);
    this.onStoreChange = this.goToMoveMoneyPage.bind(this);
    this.getSortCodeDisplayNumber = this.getSortCodeDisplayNumber.bind(this);
    this.getAccountName = this.getAccountName.bind(this);
    this.state = {
      allPayeeCardInfo: true,
      editPayeePageFlag: false,
    };
  }

  componentWillMount() {
    MoveMoneyPayeeStore.addChangeListener(this.onStoreChange);
  }

  componentDidMount() {
    sayLandingMessage(this.props.content.summaryHeaderTitle);
    window.scrollTo(0, 0);
    MoveMoneyPayeeStore.removeChangeListener(this.onStoreChange);
  }

  getSortCodeDisplayNumber() {
    let sortcode = _.split(this.props.summaryDetails.sort_code, '-');
    sortcode = NumberUtils.formatSortCode(sortcode[0]);
    // const accountNumber = this.props.data.account_number;
    return sortcode;
  }

  goToAccounts() {
    // const fromSelectedAccount = MoveMoneyStore.getSelectedAccount();
    MoveMoneyPayeeActionCreator.resetData();
    // AccountsActionCreator.getAccountsList();
    InternetBankingActions.navigateToWebTask('WEB-HOMEPAGE');
  }

  goToManagePayees() {
    MoveMoneyPayeeActionCreator.resetData();
    MoveMoneyPayeeStore.resetStore();
    MoveMoneyPayeeStore.resetFlags();
    this.props.goToManagePayees();
  }

  goToMoveMoneyPage() {
    const { isSMEUser, summaryDetails } = this.props;
    MoveMoneyStore.resetAfterAddPayee();
    if (isSMEUser) {
      const payment = {
        fromAccount: summaryDetails.accountId,
        toAccount: summaryDetails.id,
        type: 'single',
        reference: summaryDetails.reference,
      };
      setSMEPaymentAddPayee(payment);
      this.props.goToMoveMoneyPage({ hideQuickLinks: true });
      return;
    }
    MoveMoneyStore.makePaymentToThisPayee();
    this.props.goToMoveMoneyPage();
  }

  showPayeePage() {
    // call parent method to update flag to call Payee component condition
    this.props.showPayees();
    this.setState({
      allPayeeCardInfo: false,
    });
  }

  getAccountName(cop_account_name, name) {
    return cop_account_name ? cop_account_name.substring(0, 50) : name;
  }

  render() {
    const { cop_account_name, name, display_name } = this.props.summaryDetails;
    let renderContent;
    renderContent = (
      <div className="payee-summary">
        <StepHeader
          showheaderCrumbs={false}
          headerTitle={this.props.content.summaryHeaderTitle}
        />
        <div className="c-media">
          <div className="c-media__thumb">
            <SvgIcon id="icon-success" width="64px" height="64px" />
          </div>
          <div className="c-media__body">
            <p>
              <strong className="word-break-all">
                {this.props.summaryDetails.name}
              </strong>
              {this.props.content.companyAddedMsg1}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md1-18">
            <dl className="c-definitions">
              <dt className="c-definitions__key">Name</dt>
              <dd className="c-definitions__value">
                {this.getAccountName(cop_account_name, name)}
              </dd>

              <dt className="c-definitions__key">Nickname</dt>
              <dd className="c-definitions__value">{display_name || '-'}</dd>

              <dt className="c-definitions__key">Sort code</dt>
              <dd className="c-definitions__value">
                {this.getSortCodeDisplayNumber()}
              </dd>

              <dt className="c-definitions__key">Account number</dt>
              <dd className="c-definitions__value">
                {this.props.summaryDetails.account_number}
              </dd>

              <dt className="c-definitions__key">Reference</dt>
              <dd className="c-definitions__value">
                {this.props.summaryDetails.reference}
              </dd>
            </dl>
          </div>
        </div>
        <div className="payee-summary__options">
          <button
            type="button"
            className="c-btn c-btn--default"
            onClick={this.goToMoveMoneyPage}
          >
            Now make a payment to them
          </button>
          <br />
          <br />
          <button
            type="button"
            className="c-btn c-btn--secondary"
            onClick={this.goToAccounts}
          >
            Go to your accounts
          </button>
          &nbsp;
          <button
            data-test-id="go-to-manage-payees-button2"
            type="button"
            className="c-btn c-btn--secondary"
            onClick={this.goToManagePayees}
          >
            {this.props.content.goMangePayeeBtn}
          </button>
        </div>
      </div>
    );

    return (
      <div>
        {/* <h1 id="newPaymentId" ref = "newPaymentId" tabIndex = "0" className="u-visually-hidden off-screen">{this.props.content.summaryHeaderTitle}</h1> */}
        {renderContent}
      </div>
    );
  }
}

AddPayeeSummary.propTypes = {
  content: PropTypes.object,
  summaryDetails: PropTypes.object,
  showPayees: PropTypes.func,
  goToManagePayees: PropTypes.func,
  goToMoveMoneyPage: PropTypes.func,
  isSMEUser: PropTypes.bool.isRequired,
};
AddPayeeSummary.defaultProps = {
  content: {},
  summaryDetails: {},
};

export default AddPayeeSummary;
